import { render, staticRenderFns } from "./AiAppSettingDefinitionRowDetail.vue?vue&type=template&id=a386d574&scoped=true"
import script from "./AiAppSettingDefinitionRowDetail.vue?vue&type=script&lang=js"
export * from "./AiAppSettingDefinitionRowDetail.vue?vue&type=script&lang=js"
import style0 from "./AiAppSettingDefinitionRowDetail.vue?vue&type=style&index=0&id=a386d574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a386d574",
  null
  
)

export default component.exports